var objChartClickHandler = {
    // <summary>
    // This object holds everything regarding the chart click handler
    // </summary>

    _initChartClickHandlerStuff: function (me) {
        /// <summary> This function inits the whole chart click handler stuff and the chart click handler popup/menu </summary>
        try {
            var cc = me.chartClick;

            //track the mouse position - needed to position the popop menu of the chart point click handler
            $(document).mousemove(function (e) {
                me.mousePos = { x: e.pageX, y: e.pageY };
            }).mouseover();

            me.chartClick.popup = $("<div>").addClass("vc-menu").attr("id", "popupChartClickDialog").css("overflow-y", "hidden").html(objChartClickHandler._createChartClickHandlerMenu(me)).dialog({
                open: function () { objChartClickHandler._initChartClickHandlerMenu(me) },
                autoOpen: false, modal: true, width: 180, height: 95,
                resizable: false, dialogClass: "modal-popup-dialog", title: "", closeOnEscape: true, position: { my: 'top+10%', at: 'top', of: window }
            });

            cc.popup.siblings('div.ui-dialog-titlebar').remove();
            cc.popup.parents('div.ui-dialog').css("padding", 6);
            cc.popup.css("padding", 0).css("margin-top", 0);

            var eventNamespace = ".RampArchive" + me.uuid;

            $("body").on("click" + eventNamespace, function () {
                var menu = cc.menu;
                if (menu.active) {
                    if (me.mousePos.x >= menu.x && me.mousePos.x <= (menu.x + menu.w) &&
                        me.mousePos.y >= menu.y && me.mousePos.y <= (menu.y + menu.h)) {
                        menu.pending = false;
                    } else {
                        menu.active = false;
                        cc.popup.dialog("close");
                    }
                }

            });

            var size = me.getPopupSize(0.97, 0.95);
            var w = size[0];
            var h = size[1];

            cc.content = $("<div>").addClass("vc-menu").attr("id", "popupClickHandler").css("overflow-y", "hidden").html("<div class='clickHandlerContent' style='overflow:none'>").dialog({
                close: function () { _VCMQ.produce(me.visual, me.chartClick.vcgid, 'MODAL_CLOSE', ""); },
                autoOpen: false, modal: true, width: w, height: h,
                resizable: false, dialogClass: "modal-popup-dialog", title: "", closeOnEscape: true, position: { my: 'top+2%', at: 'top', of: window },
                buttons: [{
                    text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                        cc.content.dialog('close'); return true;
                    }
                }]
            });

        } catch (e) { me._writeErr(e); }
    },

    _openChartClickHandler: function (me, event) {
        /// <summary> This function sends the current ramp chart settings to the favorite lists. </summary>
        try {

            //if interval year is selected, click handler shall not work and we have to stop
            if (event.values.interval === 5) { return true; }

            //we store the chart - we will need it when every popup was closed later on to recreate the point click handler of the chart
            var mychart = window.__GLOBAL_VISUAL_LIST["ramp" + event.vcgid];
            me.chartClick.vcgid = event.vcgid;
            me.chartClick.chart = mychart;

            var menu = me.chartClick.menu;
            menu.active = true;
            menu.bsaid = event.values.senderPoint.series.name.bsaid;
            menu.date = objChartClickHandler._getDateFromChartClick(me, event.values);

            menu.w = parseInt(me.chartClick.popup.dialog("option", "width")) + 6;
            menu.h = parseInt(me.chartClick.popup.dialog("option", "height"));
            menu.x = parseInt(me.mousePos.x - (menu.w / 2));
            menu.y = parseInt(me.mousePos.y - (menu.h / 2));

            // calculate menu position in x direction depending on mouse click position, so that popup is always within the chart (and not outside of chart)
            var wHighChart = me.fnd(".highcharts-background").width();
            var mPosX = me.mousePos.x;
            var xOffset = (menu.w + 6) / 2;
            var xThreshold = wHighChart - xOffset;

            // if popup would be outside of chart, we move it to the inside of the chart
            var diff;
            if (mPosX > xThreshold) {
                diff = mPosX - xThreshold;
                menu.x = menu.x - diff;
            }

            // calculate menu position in y direction depending on mouse click position, so that popup is always within the chart (and not outside of chart)
            var hHighChart = me.fnd(".highcharts-xaxis");
            var mPosY = me.mousePos.y;
            var yOffset = (menu.h) / 2;
            var yThreshold = hHighChart.offset().top - yOffset;

            if (mPosY > yThreshold) {
                diff = mPosY - yThreshold;
                menu.y = menu.y - diff;
            }

            me.chartClick.popup.dialog('option', 'position', { my: 'left top', at: 'left+' + menu.x + ' top+' + menu.y, of: window }).dialog("open");
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _getDateFromChartClick: function (me, msg) {
        /// <summary> This function generates proper dates from a clicked point in a ramp chart. 
        /// currently the chart click handler is only available for interval 1 or 3 and not for 5 (year)
        ///</summary >
        try {       

            // check if senderPoint.n.dt is available, otherwise we get the date from the date box or via a different way
            if (typeof (msg.senderPoint.n) == "undefined" || typeof (msg.senderPoint.n.dt) == "undefined") {
                var date;

                // get current year from date box to concatenate the final date string
                var y = me.status.date.singleDate;
                y = y.substring(6, y.length);

                switch (msg.interval) {
                    case 1:
                        if (me.status.date.isSingle)
                            date = me.status.date.singleDate;
                        else {
                            var s = msg.senderPoint.category;
                            var d = s.replace(/<br\/?>.*/, "");
                            date = d + y;
                        }
                        break;
                    case 3:
                        date = msg.senderPoint.category + y;
                        break;
                    default:
                        return null;
                }
                return date;
            } else {
                var d = msg.senderPoint.n.dt;

                if (d.length < 4) { return true }

                switch (msg.interval) {
                    case 1:
                        d = d.split(',')[1].trim();
                        d = d.substring(0, 10);
                        break;
                    case 3:
                        d = d.substring(4, d.length);
                        break;
                    default:
                        return null;
                }
                return d;
            }
        } catch (e) { me._writeErr(e); return false; }
    },

    _createChartClickHandlerMenu: function (me) {
        try {
            var div = $("<div>").data("bsaid", "-1").data("date", "").addClass("click-handler-menu").css({ position: "relative" });

            var main = $("<div>").css("text-align", "center");
            main.append($("<i>").data("type", "dsedit").addClass("chart-click-icon fa-regular fa-laptop-medical color-font-secondary").css("font-size", 46)
                    .attr("title", me.specific.resources.datacenter)
                    .on("mouseenter", function () { $(this).toggleClass("color-font-secondary color-font-primary"); })
                    .on("mouseleave", function () { $(this).toggleClass("color-font-primary color-font-secondary"); })
            );
            main.append("<hr/>");

            var sub = $("<div>").css("text-align", "center");
            sub.append($("<i>").data("type", "multiplaus").addClass("chart-click-icon fa fa-arrows-to-dotted-line color-font-secondary").css("font-size", 20).css("margin-right", 8).attr("title", me.specific.resources.plaus));
            sub.append($("<i>").data("type", "singleEdit").addClass("chart-click-icon fa fa-terminal color-font-secondary").css("font-size", 20).css("margin-right", 8).attr("title", me.specific.resources.editSingleValues));
            sub.append($("<i>").data("type", "rangeEdit").addClass("chart-click-icon fa fa-list-ul color-font-secondary").css("font-size", 20).css("margin-right", 8).attr("title", me.specific.resources.editValueRange));
            sub.append($("<i>").data("type", "alarm").addClass("chart-click-icon fa fa-bell color-font-secondary").css("font-size", 20).css("margin-right", 8).attr("title", me.specific.resources.alarm));
            sub.append($("<i>").data("type", "archiveStatus").addClass("chart-click-icon fa fa-braille color-font-secondary").css("font-size", 20).css("margin-right", 8).attr("title", me.specific.resources.state));
            sub.append($("<i>").data("type", "tasks").addClass("chart-click-icon fa fa-regular fa-paper-plane color-font-secondary").css("font-size", 20).attr("title", me.specific.resources.tasks));

            // icon to hide the series of the clicked signal
            var corner = $("<div>").addClass("chart-click-corner").css({ position: "absolute", top: 4, right: 4 });
            corner.append($("<i>").data("type", "hideSeries").addClass("chart-click-icon fa fa-eye-slash color-font-secondary").css("font-size", 14).attr("title", me.specific.resources.hide));
            // ─────────────────────────────────────────────────────────────

            // hover for all icons
            div.on("mouseenter", ".chart-click-icon", function () { $(this).removeClass("color-font-secondary").addClass("color-font-primary");
            }).on("mouseleave", ".chart-click-icon", function () { $(this).removeClass("color-font-primary").addClass("color-font-secondary"); });

            div.append(main, sub, corner);
            return div;
        } catch (e) { me._writeErr(e); return $("<div>"); }
    },
    
    _initChartClickHandlerMenu: function (me) {
        /// <summary> This function handles the click events for the chart click menu </summary>
        try {
            me.chartClick.popup.find(".chart-click-icon").off("click").on("click", function (obj) {
                var type = $(obj.target).data("type");
                var bsaid = me.chartClick.menu.bsaid;
                var date = me.chartClick.menu.date;

                //we close this modal popup and open the next one with the content
                me.chartClick.popup.dialog("close");
                me.chartClick.popup.active = false;
                me.chartClick.reloadNecessary = true;
                objChartClickHandler._openChartClickHandlerContent(me, type, bsaid, date);
            });

        } catch (e) { me._writeErr(e); }
    },

    _openChartClickHandlerContent: function (me, type, bsaid, day) {
        /// <summary> This function toggles the single edit form </summary>
        var visualname = "";
        var sParameter = "";

        try {
            if (me.error) { return false; }

            //we decide which status we use
            var myStatus = null;
            //if no temp chart is active we take the main chart
            if (me.currentTempChart == null) {
                myStatus = me.status;
            } else {
                //otherwise we use the status of the temp chart
                myStatus = me.currentTempChart;
            }

            // reset content html for next popup opening
            me.chartClick.content.find(".clickHandlerContent").html("");

            // save chartclick type - info necessary during closing of the popup (e.g. if multiplaus, plausibilities must be fetched again)
            me.chartClick.type = type;

            var param = { 'loggerid': me.specific.LoggerId, 'day': day, 'bsaid': [] };
            var idName;
            switch (type) {
                case "dsedit":

                    // aqs parameter for chart - to show the correct error icons depending on the current settings
                    var aqsParameter = me.specific.StartParameter || {
                        DataCenterStart: false,
                        ShowInvalid: true,
                        ShowInplausible: true,
                        ShowMissing: true,
                        ShowRules: true,
                        IgnoreNotTagBasedValidation: false
                    };

                    me.vcV.showDsEdit2Dialog({ LoggerId: me.specific.LoggerId, bsaid: bsaid, day: day, ArchVcgid: me.vcgid, AqsParameter: aqsParameter });
                    break;
                case "hideSeries":
                    // find the series in the current chart and hide it
                    var chart = me.chartClick.chart;
                    var ser = null;
                    $.each(chart.series, function (i, s) {
                        if (s.name && s.name.bsaid === bsaid) { ser = s; return false; }
                    });

                    if (ser) {
                        // same event as legendItemClick()
                        _VCMQ.produce($('#divMUContainer' + me.chartClick.vcgid), me.chartClick.vcgid, 'CHART_SERIES_HIDE', ser.index);
                        // hide the series and redraw the chart
                        ser.setVisible(false, false);
                        chart.redraw();
                    }
                    return true;      
                    break;
                case "multiplaus":
                    $.each(myStatus.signals.selectedBsaids, function () { param.bsaid.push(parseInt(this)); });
                    visualname = "VISUAL_DATACENTER_MULTI_PLAUS";
                    sParameter = JSON.stringify(param);
                    break;
                case "alarm":
                    visualname = "VISUAL_ALARMHISTORY";
                    sParameter = JSON.stringify({ 'loggerid': me.specific.LoggerId, 'startDate': day, 'endDate': day, 'AllProjects': false, 'ShowCurrentAlarms': false, "FixedContentHeight": true });
                    break;
                case "archiveStatus":
                    $.each(myStatus.signals.selectedBsaids, function () { param.bsaid.push(parseInt(this)); });
                    visualname = "VISUAL_DATACENTER_ARCHIVESTATUS";
                    sParameter = JSON.stringify(param);
                    break;
                case 'singleEdit':
                    $.each(myStatus.signals.selectedBsaids, function () { param.bsaid.push(parseInt(this)); });
                    visualname = "VISUAL_DATACENTER_SPLIT_PEAKS";
                    sParameter = JSON.stringify(param);
                    break;
                case 'rangeEdit':
                    $.each(myStatus.signals.selectedBsaids, function () { param.bsaid.push(parseInt(this)); });
                    visualname = "VISUAL_DATACENTER_EDIT_RANGE";
                    sParameter = JSON.stringify(param);
                    break;
                case "tasks":
                    me._setSessionStorage();

                    param = { bsaids: me.status.signals.allSelectedBsaids, startDate: me.status.menu.startDate, endDate: me.status.menu.endDate, DataType: -1, LoggerId: me.specific.LoggerId };

                    //TODO MKU: check for better solution!!
                    var div = me.chartClick.content;
                    div.dialog("open");

                    // set content height/width and popup height/width
                    me.chartClick.content.dialog("option", "width", 1350);
                    me.chartClick.content.dialog("option", "height", 850);

                    // create unique clickHandlerContent id for each chart type - otherwise error!
                    idName = "divClickHandlerContent" + type;

                    var cont = { random: me.options.invoke.vcgid + 2, prefix: "my-details-" };
                    cont.obj = $("<div>").attr("id", cont.prefix + cont.random);
                    cont.obj.height(800);
                    cont.obj.width(1300);
                    div.find(".clickHandlerContent").attr("id", idName).html(cont.obj).height(800).width(1300);

                    cont.obj.SendTasks({ invokeType: "addVisualBase", parameter: param, deviceType: me.settings.deviceType });

                    break;

                default: break;
            }

            if (visualname.length === 0) { return false }

            me.chartClick.content.dialog("open");

            var size = me.getPopupSize(0.97, 0.95);
            var w = size[0];
            var h = size[1];

            // set content height/width and popup height/width
            me.chartClick.content.dialog("option", "width", w);
            me.chartClick.content.dialog("option", "height", h);

            // create unique clickHandlerContent id for each chart type - otherwise error!
            idName = "divClickHandlerContent" + type;
            me.chartClick.content.find(".clickHandlerContent").attr("id", idName).html(me.vcC.getLoadingIcon()).height(h).width(w);

            me.vcV.addVisualBaseByName("divClickHandlerContent", visualname, type, day, h - 20, w - 20, sParameter, '', 1);

            return true;

        } catch (e) { me._writeErr(e); return false; }
    }


    //TODO MKU: currently not in use??
    //_updateChartClickHandler: function (me) {
    //    /// <summary>
    //    /// This function recreates the click handler event for all series of the current chart
    //    /// Yes, it's a hack - but we lose the click handler when we open various ramp charts at the same time
    //    /// </summary>
    //    try {

    //        if (me.error) { return false; }
    //        //we decide which status we use
    //        var myStatus;
    //        //if no temp chart is active we take the main chart
    //        if (me.currentTempChart == null) {
    //            myStatus = me.status;
    //        } else {
    //            //otherwise we use the status of the temp chart
    //            myStatus = me.currentTempChart;
    //        }

    //        if (me.chartClick.chart !== null) {
    //            $.each(me.chartClick.chart.series, function (index, graph) {

    //                graph.update({
    //                    point: {
    //                        events: {
    //                            click: function () {
    //                                _VCMQ.produce(me.visual, me.chartClick.vcgid, 'RAMP_CLICK', {
    //                                    'sender': me.chartClick.vcgid, 'senderPoint': this, 'interval': myStatus.date.interval, 'dateUserDef': myStatus.date.isSingle == false
    //                                });
    //                            }
    //                        }
    //                    }
    //                }, false);
    //            });

    //            me.chartClick.chart.redraw();
    //        }
    //        return true;

    //    } catch (e) { me._writeErr(e); return false; }
    //}



};